export default __webpack_public_path__ + "static/media/Vector1.a7eaedf8.svg";